import React, { Fragment } from "react";
import classes from "./priceSummary.module.css";
import { FaRupeeSign } from "react-icons/fa";

const MINUS_SYMBOL = "-";

const DEFAULT_AMOUNT = {
  value: 0,
};

const getDiscount = (discounts = []) => {
  if (!discounts || !discounts.length) {
    return DEFAULT_AMOUNT;
  } else {
    return {
      currency: discounts[0].amount.currency,
      value: discounts.reduce(
        (acc, discount) => acc + discount.amount.value,
        0
      ),
    };
  }
};

const DiscountSummary = (props) => {
  const discount = getDiscount(props.data);

  return discount.value ? (
    <Fragment>
      <span className={classes.lineItemLabel}>
        <h6>
          <span>
            Discounts applied {`(${props.couponCodeText || "Promo Code"})`}
          </span>
        </h6>
      </span>
      <span
        className={classes.discountPriceContainer}
        style={{ color: "#1041BD" }}
      >
        {MINUS_SYMBOL}

        <span className={classes.discountPrice}>
          <FaRupeeSign />
          {discount.value}
        </span>
      </span>
    </Fragment>
  ) : null;
};

export default DiscountSummary;
